/*
 * THE ENTITY LIST'S OWN CHROME (#2406).
 *
 * Moved verbatim from `crm/crm.module.css`, where it had no business being.
 * `ListView` is the console's core collection surface — every desk renders
 * through it — and it was reaching into a FEATURE folder's stylesheet for its
 * own view picker, batch bar, fork bar, filter row, MCP reveal and record
 * identity link. That is the single clearest reason `crm.module.css` had become
 * a shadow design system: its biggest consumer was not CRM.
 *
 * The rules are unchanged. Every browser locator that reaches them is a testid
 * on the markup (`view-tabs`, `batch`, `modbar`, `filters`, `mcp`) except one —
 * `crm.spec.ts:74` matches `[class*=mine]`, a CSS-module substring, so the
 * class KEEPS the name `mine` and that assertion keeps working.
 *
 * What is NOT here: the peek header, the popover and the saved-view control's
 * own presentation, which are shared vocabulary heading for `packages/ui`
 * rather than a second private sheet. This file is the chrome that is genuinely
 * this surface's alone.
 */

.tableManagerTarget { display: flex; align-items: center; flex-wrap: wrap; gap: var(--sp-2); }
@media (pointer: coarse) { .viewPick { min-height: 44px; } }

/* The ONE view selector (2026-08-07). Replaces a <Tabs> strip that was fighting
   the title and filters for the grid bar's first row, plus a duplicate "All
   views" button at the far right. Names what is open; opens the grouped
   switcher that was always the better control. */
/* The batch buttons' private paint (.batchAct, .batchDanger) is DELETED
   (#2375): the floating GridCommandBar pill is gone, and the legacy batch
   actions are kit Buttons inside the inline selection group, which paints
   them. */
.count { padding: var(--sp-2) var(--sp-4); font-size: var(--fs-sm); color: var(--muted); }
@media (pointer: coarse) {
  .recordIdentityLink { min-height: 44px; }
}
.recordIdentityLink:focus-visible { outline: 2px solid var(--focus-ring); outline-offset: 2px; border-radius: var(--r-sm); }
/* Brand is deployment data and can be far below text contrast (the demo teal
   is 2.34:1 on compact grid cards). Keep its hue as a hint, while the governed
   ink token supplies enough contrast for the link's hover text. */
.recordIdentityLink:hover span { color: color-mix(in srgb, var(--brand) 35%, var(--ink)); text-decoration: underline; text-underline-offset: 3px; }
.recordIdentityLink span { min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }

.recordIdentityLink { display: inline-flex; align-items: center; gap: var(--sp-2); min-width: 0;
  color: var(--ink); font-weight: 680; text-decoration: none; }
.modSp { flex: 1; }
.modbar b { font-weight: 680; }

/* modified / fork bar */
.modbar { display: flex; align-items: center; gap: var(--sp-3); padding: var(--sp-2) var(--sp-4); font-size: var(--fs-sm);
  background: var(--warn-bg); color: var(--warn); }
.mcpCode { font-family: var(--font-mono); font-size: 11px; color: var(--muted); white-space: pre-wrap; word-break: break-word; line-height: 1.6; }
.mcpTool { font-family: var(--font-mono); font-size: 11px; font-weight: 700; color: var(--brand-text); flex: none; }
.mcp { display: flex; gap: var(--sp-3); align-items: baseline; padding: var(--sp-3) var(--sp-4); background: color-mix(in srgb, var(--brand) 4%, var(--bg)); }
/* filter chips + MCP reveal */
.frow { display: flex; align-items: center; gap: 7px; padding: var(--sp-3) var(--sp-4); flex-wrap: wrap;
  border-bottom: 1px solid var(--hair); background: var(--bg); }
